// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2iBLq","info":"UpdateTermsInfo_info__3wXJv"};